import { render, staticRenderFns } from "./LatestNewsAnnouncements.vue?vue&type=template&id=027ddfac&scoped=true&"
import script from "./LatestNewsAnnouncements.vue?vue&type=script&lang=js&"
export * from "./LatestNewsAnnouncements.vue?vue&type=script&lang=js&"
import style0 from "./LatestNewsAnnouncements.vue?vue&type=style&index=0&id=027ddfac&prod&lang=scss&"
import style1 from "./LatestNewsAnnouncements.vue?vue&type=style&index=1&id=027ddfac&prod&lang=scss&scoped=true&"
import style2 from "./LatestNewsAnnouncements.vue?vue&type=style&index=2&id=027ddfac&prod&lang=scss&scoped=true&"
import style3 from "./LatestNewsAnnouncements.vue?vue&type=style&index=3&id=027ddfac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027ddfac",
  null
  
)

export default component.exports